module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footers"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer fwc"
  }, [_c('div', {
    staticClass: "footerBox"
  }, [_c('div', {
    staticClass: "footerTop fwc"
  }, [_c('div', {
    staticClass: "ftLeft fhs"
  }, [_c('img', {
    attrs: {
      "src": _vm.$fileUrl + _vm.companys.logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ftMid"
  }, [_c('div', {
    staticClass: "cow dv1"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.go(0)
      }
    }
  }, [_vm._v("公司简介")]), _vm._v(" |\n            "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.go(1)
      }
    }
  }, [_vm._v("产品技术")]), _vm._v(" |\n            "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.go(2)
      }
    }
  }, [_vm._v("案例展示")]), _vm._v(" |\n            "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.go(3)
      }
    }
  }, [_vm._v("新闻资讯")]), _vm._v(" |\n            "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.go(4)
      }
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('div', {
    staticClass: "cow dv2"
  }, [_vm._v("江苏冰谷数字科技有限公司（江苏省无锡市滨湖区锦溪路100号）")]), _vm._v(" "), _c('div', {
    staticClass: "cow dv3"
  }, [_vm._v("服务热线：400-926-3100 邮 箱：jiangsubinggu@jsbingo.cn")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticStyle: {
      "opacity": ".3",
      "color": "white",
      "font-size": "12px",
      "line-height": "1.3"
    }
  }, [_vm._v("公共安全体验馆设计厂家,展示区,施工方案,价格,哪家好")])]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cow foottxt"
  }, [_c('p', [_vm._v("电话：400-926-3100")]), _vm._v(" "), _c('p', [_vm._v("邮箱：jiangsubinggu@jsbingo.cn")]), _vm._v(" "), _c('p', [_vm._v("地址：江苏省无锡市滨湖区锦溪路100号")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "opacity": "0.3"
    }
  }, [_vm._v("Copyright © 2008-2020 江苏冰谷数字科技有限公司")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "opacity": "0.1"
    }
  }, [_vm._v("公共安全体验馆设计厂家,展示区,施工方案,价格,哪家好")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/c0.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cow dv4"
  }, [_vm._v("\n            版权所有 Copyright © 2020 江苏冰谷数字科技有限公司\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("苏 ICP备18041182号-1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftRight fws"
  }, [_c('div', {
    staticClass: "ftt fhs"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c0.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("官方公众号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bc2b5aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Footer.vue
// module id = 300
// module chunks = 0 1 2 3 4 5 6 7 8 9